import { ONGOING_EXPERIMENTS } from 'constants/eppo';

import { useFeatureFlagWithAQA } from 'services/Eppo';

import CancellationReasonModalA from './CancellationReasonModalA';
import CancellationReasonModalControl from './CancellationReasonModalControl';

const CancellationReasonModal = () => {
    const { value: variant } = useFeatureFlagWithAQA<string>({
        flagKey: ONGOING_EXPERIMENTS.EarlierInterception,
        defaultValue: 'Control',
        type: 'string',
    });

    switch (variant) {
        case 'A':
            return <CancellationReasonModalA />;

        default:
            return <CancellationReasonModalControl />;
    }
};

export default CancellationReasonModal;
